import ehDiaUtil from 'eh-dia-util';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { MES } from '../../../../commons/constant/meses';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Calcula o número de dias úteis até a data atual em um mês específico.
 *
 * @param {string} currentDate - A data atual no formato de string (YYYY-MM-DD).
 * @returns {number} O número de dias úteis até a data atual no mês especificado.
 */
export function calculateWorkingDays(currentDate) {
  const date = dayjs(currentDate).tz('America/Sao_Paulo');
  const year = date.year();
  const month = date.month();
  const today = date.date();

  const mesesDiasUteisConfigurados =
    year === 2024 && [MES.JULHO, MES.AGOSTO].includes(month);

  if (mesesDiasUteisConfigurados) {
    return Math.min(20, calculateWorkingDaysWithOverride(currentDate));
  }

  let workingDays = 0;
  for (let day = 1; day <= today; day++) {
    const currentDay = dayjs(new Date(year, month, day)).tz(
      'America/Sao_Paulo',
    );
    if (ehDiaUtil(currentDay.toDate())) {
      workingDays++;
    }
  }

  return workingDays;
}

/**
 * Calcula o número total de dias úteis em um mês específico.
 *
 * @param {string} dateStr - Uma string representando o mês e o ano para o cálculo (YYYY-MM-DD).
 * @returns {number} O número total de dias úteis no mês especificado.
 */
export function totalWorkingDaysInDate(dateStr) {
  const date = dayjs(dateStr).tz('America/Sao_Paulo');
  const year = date.year();
  const month = date.month();

  const mesesDiasUteisConfigurados =
    year === 2024 && [MES.JULHO, MES.AGOSTO].includes(month);
  if (mesesDiasUteisConfigurados) {
    return 20;
  }

  const totalDays = dayjs(new Date(year, month + 1, 0))
    .tz('America/Sao_Paulo')
    .date();
  let workingDays = 0;

  for (let day = 1; day <= totalDays; day++) {
    const currentDay = dayjs(new Date(year, month, day)).tz(
      'America/Sao_Paulo',
    );
    if (ehDiaUtil(currentDay.toDate())) {
      workingDays++;
    }
  }

  return workingDays;
}

/**
 * Função auxiliar para calcular o número de dias úteis com a biblioteca eh-dia-util.
 *
 * @param {string} currentDate - A data atual no formato de string (YYYY-MM-DD).
 * @returns {number} O número de dias úteis até a data atual no mês especificado.
 */
function calculateWorkingDaysWithOverride(currentDate) {
  const date = dayjs(currentDate).tz('America/Sao_Paulo');
  const year = date.year();
  const month = date.month();
  const today = date.date();

  let workingDays = 0;
  for (let day = 1; day <= today; day++) {
    const currentDay = dayjs(new Date(year, month, day)).tz(
      'America/Sao_Paulo',
    );
    if (ehDiaUtil(currentDay.toDate())) {
      workingDays++;
    }
  }

  return workingDays;
}
